import { ErrorHandler, Injectable, Injector, Inject } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { NotificationsService } from "../core/services/notifications.service";
import { PortalModulesService } from "../core/services/portal-modules.service";
import { SpinnerService } from "../core/services/spinner.service";

@Injectable()
export class GlobalErrorInterceptor extends ErrorHandler {
  constructor(@Inject(Injector) private injector: Injector) {
    super();
  }

  //for pages that do not include in module list, add the path here
  private readonly extraPaths = ['/account/login', '/home/bulletin', '/office', '/careers'];

  private get notificationsService(): NotificationsService {
    return this.injector.get(NotificationsService);
  }

  private get portalModulesService(): PortalModulesService {
    return this.injector.get(PortalModulesService);
  }

  private get spinnerService(): SpinnerService {
    return this.injector.get(SpinnerService);
  }

  handleError(error: any) {
    this.spinnerService.closeModal();
    if (!(error instanceof HttpErrorResponse)) {
      if (error.rejection)
        error = error.rejection;
    }

    if (error) {
      let pageUrl = window.location.pathname;
      let modules = this.portalModulesService.getPortalModules();
      let currentModule, isAcceptablePath;

      currentModule = modules?.find(module => pageUrl.toLowerCase().indexOf(module.ModuleActionName.toLowerCase()) > -1);

      if (currentModule == null)
        isAcceptablePath = this.extraPaths.find(path => pageUrl.toLowerCase().indexOf(path.toLowerCase()) > -1);

      if (currentModule?.UseGlobalErrorHandler || isAcceptablePath) {
        this.notificationsService.showError(error.error?.error ?? "An error has occurred", error.url);
      }
      super.handleError(error);
    }
  }
}
